import {Alias} from './../alias.js';
import * as sessionObjects from './SessionObjects.js';

import {ConfigUtils} from '../../shared/utils/ConfigUtils';
import {CountryUtils} from '../../shared/utils/CountryUtils';
import {BaseFilterModel} from '../../shared/model/filter/BaseFilterModel';
import {VarietyCollection} from '../../shared/collection/md/VarietyCollection';
import {TillageSystemCollection} from '../../shared/collection/md/TillageSystemCollection';
import {FarmFeaturesCollection} from '../../shared/collection/users/FarmFeaturesCollection';
import {BaseModel} from '../../shared/model/base/BaseModel';
import {router} from '../router';

// can extend basic config class to share .getCountryRelatedAliases
export class ResourcesConfig {

    static getConfig () {

        return {

            defaults: {
                'default': [
                    ResourcesConfig.RESOURCE_NAME.USER,
                ],
                [Alias.HOME]: [],
                [Alias.FORWARD_LAYOUT]: [],
                [Alias.V2_APP]: [],

                // User routes
                [Alias.USER_SETTINGS]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.INVITE_COLLABORATORS]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.SCOUTING]: ResourcesConfig.basicCommonResourceSet(),

                // Farm routes
                [Alias.FARM]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.FARM_SETTINGS]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.FARM_LICENSES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.CROSS_FARM_DASHBOARD]: [
                    ResourcesConfig.RESOURCE_NAME.CROPS,
                    ResourcesConfig.RESOURCE_NAME.STRESSES,
                    ResourcesConfig.RESOURCE_NAME.VARIETIES,
                    ResourcesConfig.RESOURCE_NAME.SOIL_TEXTURES,
                    ResourcesConfig.RESOURCE_NAME.SOIL_TAXONOMIES
                ],
                [Alias.DOWNLOAD_HISTORY]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.CONNECTED_APPS]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.DATA_ATTRIBUTION]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.STATUS]: [
                    ...ResourcesConfig.extendedCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.SOIL_TEXTURES,
                    ResourcesConfig.RESOURCE_NAME.SOIL_TAXONOMIES
                ],
                [Alias.MANAGEMENT_ZONES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.DRAW_MANAGEMENT_ZONES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.EDIT_MANAGEMENT_ZONES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.AB_LINES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.DRAW_AB_LINES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.EDIT_AB_LINES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.DRAW_TRAMLINES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.EDIT_TRAMLINES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.FIELD_ENTRIES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.ADD_FIELD_ENTRIES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.EDIT_FIELD_ENTRIES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.WEATHER]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.WEATHER_STATIONS]: ResourcesConfig.extendedCommonResourceSet(),

                // Field routess
                [Alias.DRAW]: [
                    ...ResourcesConfig.basicCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.FIELDS,
                    ResourcesConfig.RESOURCE_NAME.CROP_SEASONS
                ],
                [Alias.BOUNDARY_DETECTION]: [
                    ...ResourcesConfig.basicCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.FIELDS
                ],
                [Alias.BOUNDARY_DETECTION_SUCCESS]:ResourcesConfig.basicCommonResourceSet(),
                [Alias.FIELD_UPLOAD]: [
                    ...ResourcesConfig.basicCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.FIELDS
                ],
                [Alias.FIELD_UPLOAD_SUCCESS]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.EDIT_FIELD]: [
                    ...ResourcesConfig.basicCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.FIELDS,
                    ResourcesConfig.RESOURCE_NAME.CROP_SEASONS
                ],
                [Alias.CREATE]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.DRAW_SUCCESS]: ResourcesConfig.basicCommonResourceSet(),
                [Alias.ASSIGN_CS]: [
                    ...ResourcesConfig.extendedCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.VARIETIES,
                    ResourcesConfig.RESOURCE_NAME.TILLAGE_SYSTEMS,
                    ResourcesConfig.RESOURCE_NAME.CROP_USAGES
                ],
                [Alias.EDIT_CS]: [
                    ...ResourcesConfig.extendedCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.VARIETIES,
                    ResourcesConfig.RESOURCE_NAME.TILLAGE_SYSTEMS,
                    ResourcesConfig.RESOURCE_NAME.CROP_USAGES
                ],
                [Alias.TIMING]: ResourcesConfig.extendedCommonResourceSet(),

                // Task routes
                [Alias.TASKS]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_SPRAYING_CREATE]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_OBSERVATION_CREATE]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_DRONE_FLIGHT_CREATE]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_SPRAYING_EDIT]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_NUTRITION_CREATE]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_NUTRITION_EDIT]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_HERBICIDE_CREATE]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_HERBICIDE_EDIT]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_SCOUTING_CREATE]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.TASK_SCOUTING_EDIT]: ResourcesConfig.extendedCommonResourceSet(),


                // Fields
                [Alias.FIELDS]: ResourcesConfig.extendedCommonResourceSet(),

                // Healthy Fields
                [Alias.HEALTHY_FIELDS_OVERVIEW]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.HEALTHY_FIELDS_SERVICES]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.HEALTHY_FIELDS_REQUEST]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.HEALTHY_FIELDS_CONTRACTOR_REQUEST]: ResourcesConfig.extendedCommonResourceSet(),
                [Alias.HEALTHY_FIELDS_DASHBOARD]: ResourcesConfig.basicCommonResourceSet(),

                // Shop
                [Alias.SHOP_PRODUCTS]: ResourcesConfig.extendedCommonResourceSet(),
                // Field data layers
                [Alias.FIELD_DATA_LAYERS]: [
                    ...ResourcesConfig.basicCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.FIELDS,
                    ResourcesConfig.RESOURCE_NAME.CROP_SEASONS,
                    ResourcesConfig.RESOURCE_NAME.CROPS,
                    ResourcesConfig.RESOURCE_NAME.VARIETIES,
                ],

                [Alias.FDL_UPLOADS]: [
                    ...ResourcesConfig.basicCommonResourceSet(),
                    ResourcesConfig.RESOURCE_NAME.FIELDS,
                    ResourcesConfig.RESOURCE_NAME.CROP_SEASONS,
                ],

                [Alias.SHOP_ORDER]: ResourcesConfig.extendedCommonResourceSet(),

                // Login routes
                [Alias.LOGIN]: [],
                [Alias.RESET_PASS]: [],
                [Alias.FORGOT_PASS]: [],
                [Alias.REGISTRATION]: [],
                [Alias.REGISTRATION_2019]: [],
                [Alias.REGISTRATION_HEALTHY_FIELDS]: [],
                [Alias.REGISTRATION_HF_CONTRACTOR]: [],
                [Alias.REGISTRATION_HEALTHY_FIELDS_CONTRACTOR]: [],

                // Error routes
                [Alias.NOT_AUTHORIZED]: [],
                [Alias.PAGE_NOT_FOUND]: [],

                // Under Construction route
                [Alias.UNDER_CONSTRUCTION]: [],

                // T&C accepted route
                [Alias.TC_ACCEPTED]: [],

                // T&C accepted route
                [Alias.EMAIL_VERIFIED]: []
            }
        };
    }

    /**
     * Will return a list of resources to load taking into account:
     *   - route
     *   - user country
     *
     * @param {String} alias
     * @param {RouteEvent} routeEvent
     *
     * @returns {Array<String>}
     */
    static getResourceListToLoad (alias, routeEvent) {

        let config = ConfigUtils.getCountryConfig(ResourcesConfig.getConfig(), routeEvent);

        return (config[alias] ? config[alias] : []);
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static user (ev) {

        let user = sessionObjects.CURRENT_USER;

        if (ev.queryParams && ev.queryParams.email && user.attributes.email !== ev.queryParams.email) {

            user.set('email', ev.queryParams.email);
        }

        // User already initiated (route change or page reload)
        if (user.get('uuid') &&
            !ev.queryParams.hasOwnProperty('existing_xarvio_user')) { // Special registration flow

            // Dependencies not fetched => get settings and distributors
            if (_.isNull(user.depsFetched)) {
                user.fetchDeps();
            }

            // Profile is not fetched => get profile from gigya
            if (_.isNull(user.profileFetched)) {

                user.fetchProfile({extraProfileFields: 'address,phones,languages', include: 'profile, data, emails', UID: user.get('uuid')}).done((response) => {

                    if(response && response.profile){
                        user.setProfileInfo(response.profile, response.data, response.isVerified, response.emails);
                    }

                    let getLastEvent = router.getLastEvent();
                    let countryCode = router.getLastEventCountryCode();
                    let localeCode = router.getLastEventLanguageCode();

                    if (getLastEvent && getLastEvent.routeNamedArgs) {
                        user.checkCountryMismatch(countryCode, localeCode);
                    }
                });
            }

            return  $.when(user.depsFetched, user.profileFetched).then(() => user);
        }

        // Login page state.
        return $.Deferred().resolve(user);
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static farm (ev) {

        let def = $.Deferred();

        let next = ev.routeNamedArgs.farmUuid;
        let curr = sessionObjects.CURRENT_FARM.get('uuid');

        if (next && curr !== next) {

            sessionObjects.CURRENT_FARM.set('uuid', next);
            sessionObjects.CURRENT_FARM.fetch()
                .done(() => {

                    if (BaseModel.timezone !== sessionObjects.CURRENT_FARM.get('timezone')) {
                        sessionObjects.CURRENT_FARM.updateBaseTimezone();
                    }

                    def.resolve(sessionObjects.CURRENT_FARM);
                })
                .fail(() => { def.reject(); });
        } else {
            def.resolve(sessionObjects.CURRENT_FARM);
        }

        return def.promise();
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static fields (ev) {

        let def = $.Deferred();

        let next = ev.routeNamedArgs.farmUuid;
        let curr = sessionObjects.CURRENT_FIELDS.farmUuid;

        if(next && curr !== next){
            sessionObjects.CURRENT_FIELDS.farmUuid = next;
            sessionObjects.CURRENT_FIELDS.reset();
            sessionObjects.CURRENT_FIELDS.update({}, true).then(()=>{
                def.resolve(sessionObjects.CURRENT_FIELDS);
            });
        } else {
            def.resolve(sessionObjects.CURRENT_FIELDS);
        }

        return def.promise();
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static varieties (ev) {

        let def = $.Deferred();

        //@TODO: Implement caching logic based on $languageCode and countryUuid
        try {
            // read users country from token
            let country = sessionObjects.CURRENT_USER.getCountry();
            // map country to registration country uuid
            let countryUuid = JSON.stringify([CountryUtils.getRegistrationCountryUuid(country)]);
            // convert language code to master data format
            let lang  = CountryUtils.getLanguageCodeByUrlParam(ev.routeNamedArgs.languageCode);

            let varieties = new VarietyCollection([], {
                filterParams : new BaseFilterModel({
                    $languageCode: lang.toUpperCase(),
                    countryUuid: countryUuid,
                    registrationStatusUuid: [VarietyCollection.REGISTRATION_STATUSES.REGISTERED.uuid]
                })
            });

            // fetch varieties
            varieties.update().then(() => {
                def.resolve(varieties);
            },() => {
                def.reject(varieties);
            });
        } catch (error) {
            def.reject();
        }

        return def;
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static crops (ev) {

        let userUuid = sessionObjects.CURRENT_USER.get('uuid');
        let crops = sessionObjects.CROPS;

        if (userUuid && !crops.length) {

            let def = $.Deferred();

            crops.setFilterParams(new BaseFilterModel({
                $languageCode: CountryUtils.getLanguageCodeByUrlParam(ev.routeNamedArgs.languageCode).toUpperCase()
            }))
            .done(() => {
                def.resolve(crops);
            })
            .fail(() => {
                def.reject();
            });
            return def.promise();
        }

        return $.Deferred().resolve(crops);
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static tillageSystems (ev) {

        let tillages = new TillageSystemCollection([], {
            filterParams: new BaseFilterModel({
                $languageCode: CountryUtils.getLanguageCodeByUrlParam(ev.routeNamedArgs.languageCode).toUpperCase()
            })
        });

        return tillages.update().then(() => tillages);
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static cropSeasons () {

        let def = $.Deferred();

        sessionObjects.CURRENT_FIELDS.update({}, true).then(()=>{

            let uuids = sessionObjects.CURRENT_FIELDS.map((field)=>{
                return field.get('uuid');
            });

            if(_.isEmpty(uuids)){
                sessionObjects.CURRENT_CROP_SEASONS.dropFilterParams();
                def.resolve(sessionObjects.CURRENT_CROP_SEASONS);
            } else {

                let currentFilter = sessionObjects.CURRENT_CROP_SEASONS.getFilterParams();

                if(!currentFilter || currentFilter && _.difference(currentFilter.get('fieldUuid'), uuids).length > 0) {
                    // current selected farm has a different field list than the cached one => fetch collection
                    sessionObjects.CURRENT_CROP_SEASONS.reset();
                    sessionObjects.CURRENT_CROP_SEASONS.setFilterParams(new BaseFilterModel({
                        fieldUuid: uuids
                    })).then(() => {
                        def.resolve(sessionObjects.CURRENT_CROP_SEASONS);
                    });
                } else {
                    // current selected farm has the field list than the cached one => use existing collection
                    def.resolve(sessionObjects.CURRENT_CROP_SEASONS);
                }
            }
        });

        return def.promise();
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static stresses (ev) {

        let userUuid = sessionObjects.CURRENT_USER.get('uuid');
        let stresses = sessionObjects.STRESSES;

        if (userUuid && !stresses.length) {

            let def = $.Deferred();

            stresses.setFilterParams(new BaseFilterModel({
                $languageCode: CountryUtils.getLanguageCodeByUrlParam(ev.routeNamedArgs.languageCode).toUpperCase()
            }))
            .done(() => {
                def.resolve(stresses);
            })
            .fail(() => {
                def.reject();
            });

            return def.promise();
        }

        return $.Deferred().resolve(stresses);
    }

    /**
     * @deprecated GraphqlConfig will be used to fetch resources
     */
    static farmFeatures (ev, options = {}) {

        let def = $.Deferred();

        const farmFeatures = sessionObjects.CURRENT_FARM_FEATURES;

        let curr = farmFeatures.get('farmUuid');
        let next = ev.routeNamedArgs.farmUuid;

        if ((next && curr !== next) || options.forceUpdate) {

            let collection = new FarmFeaturesCollection([], {
                filterParams: new BaseFilterModel({
                    farmUuid: [next]
                })
            });

            collection
                .update()
                .done(() => {
                    if (collection.length) {

                        sessionObjects.CURRENT_FARM_FEATURES.set(collection);
                        def.resolve(sessionObjects.CURRENT_FARM_FEATURES);
                    } else {

                        sessionObjects.CURRENT_FARM_FEATURES.reset();
                        def.resolve(sessionObjects.CURRENT_FARM_FEATURES);
                    }
                })
                .fail(() => {

                    sessionObjects.CURRENT_FARM_FEATURES.reset();
                    def.resolve(sessionObjects.CURRENT_FARM_FEATURES);
                });
        } else {
            def.resolve(sessionObjects.CURRENT_FARM_FEATURES);
        }

        return def.promise();
    }

    static fetch (ClassName, models, options) {

        let fetchingObj = new ClassName(models, options);

        // Collections that extends BaseCollection uses .update() against .fetch() to prevent fetching collisions
        return fetchingObj[fetchingObj.update ? 'update' : 'fetch']().then(function () {

            return fetchingObj;
        });
    }

    static basicCommonResourceSet () {

        return [
            ResourcesConfig.RESOURCE_NAME.FARM,
            ResourcesConfig.RESOURCE_NAME.CROPS,
            ResourcesConfig.RESOURCE_NAME.STRESSES
        ];
    }

    static extendedCommonResourceSet () {

        return [
            ResourcesConfig.RESOURCE_NAME.FARM,
            ResourcesConfig.RESOURCE_NAME.CROPS,
            ResourcesConfig.RESOURCE_NAME.STRESSES,
            ResourcesConfig.RESOURCE_NAME.FARM_FEATURES,
            ResourcesConfig.RESOURCE_NAME.FIELDS,
            ResourcesConfig.RESOURCE_NAME.CROP_SEASONS,
            ResourcesConfig.RESOURCE_NAME.VARIETIES
        ];
    }

    static get RESOURCE_NAME () {

        return {
            USER: 'user',
            FARM: 'farm',
            CROPS: 'crops',
            STRESSES: 'stresses',
            FARM_FEATURES: 'farmFeatures',
            FIELDS: 'fields',
            CROP_SEASONS: 'cropSeasons',
            VARIETIES: 'varieties',
            TILLAGE_SYSTEMS: 'tillageSystems',
            CROP_USAGES: 'cropUsages',
            SOIL_TEXTURES: 'soilTextures',
            SOIL_TAXONOMIES: 'soilTaxonomies'
        };
    }
}


// WEBPACK FOOTER //
// ./js/resources/config.js